import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-status-stable.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";
import { ReactComponent as AlertImg } from "../../../img/ico-status-alert.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-status-block.svg";

import VolumeAdd from "./VolumeAdd";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import VolumeUpdate from "./VolumeUpdate";
import VolumeSnapshotAdd from "./VolumeSnapshotAdd";
import VolumeSnapshotUpdate from "./VolumeSnapshotUpdate";
import VolumeVmImageUpload from "./VolumeVmImageUpload";
import { DropdownType } from "../../base/CustomDropdown";



interface VolumeSnapshotData {
    volume_snapshot_id: string;
    volume_snapshot_name: string;
    volume_snapshot_status_code: string;
    volume_size_gb: number;
    boot_yn: boolean;
    create_ts: string;
    update_ts: string;
}

export interface VolumeData {
    volume_id: string;
    volume_name: string;
    volume_description: string;
    volume_status_code: string;
    boot_yn: boolean;
    volume_size_gb: number;
    mapping_device_name: string;
    base_vm_image_name: string;
    volume_type: {
      volume_type_id: string;
      volume_type_name: string;
    }
    vm: {
      vm_id: string;
      vm_name: string;
    }
    project: {
      project_id: string;
      project_name: string;
    },
    volume_snapshots: VolumeSnapshotData[];
    availability_zone_id: string;
    create_ts: string;
    update_ts: string;

}



export const categoryFilters:ListFilter[] = [
    {
        id: 1,
        name: i18n.t("TOTAL_TEXT"),
        type: "",
        code: "",
        count: 0
    },
    {
        id: 2,
        name: i18n.t("ACTIVE_TEXT"),
        type: "volumeStatusCode",
        code: "AVB",
        count: 0
    },
    {
        id: 3,
        name: i18n.t("IN_USE_TEXT"),
        type: "volumeStatusCode",
        code: "INUSE",
        count: 0
    },
    {
        id: 4,
        name: i18n.t("CREATING_TEXT"),
        type: "volumeStatusCode",
        code: "CRT",
        count: 0
    },
    {
        id: 5,
        name: i18n.t("ERROR_TEXT"),
        type: "volumeStatusCode",
        code: "ERR",
        count: 0
    },
    {
        id: 6,
        name: i18n.t("ATTACHING_TEXT"),
        type: "volumeStatusCode",
        code: "ATTCH",
        count: 0
    },
    {
        id: 7,
        name: i18n.t("DETACHING_TEXT"),
        type: "volumeStatusCode",
        code: "DTACH",
        count: 0
    },
    {
        id: 8,
        name: i18n.t("DOWNLOADING_TEXT"),
        type: "volumeStatusCode",
        code: "DWLDN",
        count: 0
    },
    {
        id: 9,
        name: i18n.t("DELETING_TEXT"),
        type: "volumeStatusCode",
        code: "DELN",
        count: 0
    },
    {
        id: 10,
        name: i18n.t("UPLOADING"),
        type: "volumeStatusCode",
        code: "UPLDN",
        count: 0
    },
    {
        id: 11,
        name: i18n.t("EXTENDING_TEXT"),
        type: "volumeStatusCode",
        code: "EXTN",
        count: 0
    },
    {
        id: 12,
        name: i18n.t("ERROR_DELEING_TEXT"),
        type: "volumeStatusCode",
        code: "ERRDELN",
        count: 0
    },
    {
        id: 13,
        name: i18n.t("BACKING_UP_TEXT"),
        type: "volumeStatusCode",
        code: "BCKUP",
        count: 0
    },
    {
        id: 14,
        name: i18n.t("RESTORING_BACKUP_TEXT"),
        type: "volumeStatusCode",
        code: "RSTOREBCK",
        count: 0
    },
    {
        id: 15,
        name: i18n.t("RESERVED_TEXT"),
        type: "volumeStatusCode",
        code: "RSRV",
        count: 0
    },
    {
        id: 16,
        name: i18n.t("ERROR_RESTORING_TEXT"),
        type: "volumeStatusCode",
        code: "ERRRSTORE",
        count: 0
    },
    {
        id: 17,
        name: i18n.t("ERROR_EXTENDING_TEXT"),
        type: "volumeStatusCode",
        code: "ERREXT",
        count: 0
    },
];


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("VOLUME_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "VOLUME_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "VOLUME_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "VOLUME_SYNC",
        },
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("NAME_TEXT"),
        accessor: "volume_name",
        disableSortBy: false,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("VOLUME_SIZE_TEXT"),
        accessor: "volume_size_gb",
        disableSortBy: false,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value} GB</div>)
    },
    {
        Header: i18n.t("STATUS_TEXT"),
        accessor: "volume_status_code",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.statusContainer}>
                {
                    (() => {
                        if(value === "AVB")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#3a8344"}}>
                                <ActiveImg style={className.statusImg}/> <>{i18n.t("AVAIL_TEXT")}</>
                            </div>)
                        else if(value === "INUSE")
                            return (
                                <div style={{...className.statusInnerContainer, color:"#8c8c8c"}}>
                                <IdleImg style={className.statusImg}/><>{i18n.t("INUSE_TEXT")}</>
                            </div>)
                        else
                            return (
                                <div style={{...className.statusInnerContainer, color:"#e86045"}}>
                                <ErrorImg style={className.statusImg}/><>{i18n.t("UNAVAIL_TEXT")}</>
                            </div>)
                    })()
                }
            </div>
        )
    },
    {
        Header: i18n.t("VM_AVAIL_ZONE_TEXT"),
        accessor: "availability_zone_id",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("VM_NAME_TEXT"),
        accessor: "vm",
        disableSortBy: true,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value?.vm_name ? value.vm_name : '-'}</div>)
    },
    {
        Header: i18n.t("VOLUME_CONNECT_TEXT"),
        accessor: "mapping_device_name",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, overflow: "hidden"}}>{value ? value : '-'}</div>)
    },
    {
        Header: i18n.t("BOOT_AVAILABLE_CHECK_TEXT"),
        accessor: "boot_yn",
        disableSortBy: true,
        style: {
            width: "70px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, color: "#0853fb", justifyContent: "center", display: "flex", marginRight: 10}}>
                {value ? "Y" : "N"}
            </div>
        )
    },
    {
        Header: i18n.t("PROJECT_TEXT"),
        accessor: "project",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value?.project_name ? value.project_name : '-'}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.dateContainer}>{value ? parseLocaleDatetime(value) : "-"}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.dateContainer, color: "#9ea0a5"}}>{value ? parseLocaleDatetime(value) : "-"}</div>)
    },

];

export const volumeAddModalContent = {
    title: i18n.t("VM_VOLUME_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <VolumeAdd />,
}

export const volumeUpdateModalContent = {
    title: i18n.t("VM_VOLUME_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <VolumeUpdate />,
}

export const snapshotAddModalContent = {
    title: i18n.t("SNAPSHOT_VOLUME_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <VolumeSnapshotAdd />,
}

export const snapshotUpdateModalContent = {
    title: i18n.t("SNAPSHOT_VOLUME_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <VolumeSnapshotUpdate />,
}

export const vmImageUploadModalContent = {
    title: i18n.t("VM_IMAGE_SEND_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("SEND_TEXT")
        },
    ],
    innerComponent: <VolumeVmImageUpload />,
}


export const diskTypes = [
    {
        label: i18n.t("BLANK_DISK_TEXT"),
        value: "BLK"
    },
    {
        label: i18n.t("IMAGE_TYPE_TEXT"),
        value: "IMG"
    },
    {
        label: i18n.t("VOLUME_TYPE_TEXT"),
        value: "VOL"
    }
]


export const imageFormatDropdownItem:DropdownType[] = [
    // {
    //     value: "ISO",
    //     label: "ISO"
    // },
    {
        value: "QCOW",
        label: "QCOW2"
    },
    {
        value: "RAW",
        label: "RAW"
    },
    {
        value: "VDI",
        label: "VDI"
    },
    {
        value: "VHD",
        label: "VHD"
    },
    {
        value: "VMDK",
        label: "VMDK"
    },
]

export const guestOsDropdownItem:DropdownType[] = [
    {
        value: "NONE",
        label: "NONE"
    },
    {
        value: "ARCH",
        label: "ARCH"
    },
    {
        value: "CENTOS",
        label: "CENTOS"
    },
    {
        value: "DEBIAN",
        label: "DEBIAN"
    },
    {
        value: "FEDORA",
        label: "FEDORA"
    },
    {
        value: "FREEBSD",
        label: "FREEBSD"
    },
    {
        value: "GENTOO",
        label: "GENTOO"
    },
    {
        value: "MANDRAKE",
        label: "MANDRAKE"
    },
    {
        value: "MANDRIVA",
        label: "MANDRIVA"
    },
    {
        value: "MES",
        label: "MES"
    },
    {
        value: "MSDOS",
        label: "MSDOS"
    },
    {
        value: "NETBSD",
        label: "NETBSD"
    },
    {
        value: "NETWARE",
        label: "NETWARE"
    },
    {
        value: "OPENBSD",
        label: "OPENBSD"
    },
    {
        value: "OPENSOLARIS",
        label: "OPENSOLARIS"
    },
    {
        value: "OPENSUSE",
        label: "OPENSUSE"
    },
    {
        value: "RHEL",
        label: "RHEL"
    },
    {
        value: "SLED",
        label: "SLED"
    },
    {
        value: "UBUNTU",
        label: "UBUNTU"
    },
    {
        value: "WINDOWS",
        label: "WINDOWS"
    },
]

const className = {
    rowContainer: {
        width: "100%"
    },
    statusContainer: {
        width: "100px",
        display: "flex",
        alignItems: "center",
    },
    statusInnerContainer: {
        display: "flex", alignItems: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#616266",
        overflow: "hidden"
    },
    statusInnerNoImageContainer: {
        marginLeft: 20,
        display: "flex",
        alignItems: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#616266",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3,
    },
    dateContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        lineHeight: "1",
        color: "#333",
        overflow: "hidden"
    },
}